module.exports = __webpack_public_path__ + "static/dan-armstrong-42477b029062973d7bf3b6ab1aadf52f.jpg";